import React, { SVGProps } from 'react'
const SvgCheckCircled = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <g fill={props.fill || 'var(--color-highlight)'} fillRule="nonzero">
      <path d="M8.545 11.97a.75.75 0 0 0-1.06 1.06l2.828 2.83a.75.75 0 0 0 1.06 0l5.657-5.658a.75.75 0 1 0-1.06-1.06l-5.127 5.126-2.298-2.298Z" />
      <path d="M12 21.75c5.385 0 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25 2.25 6.615 2.25 12s4.365 9.75 9.75 9.75Zm0-1.5a8.25 8.25 0 1 1 0-16.5 8.25 8.25 0 0 1 0 16.5Z" />
    </g>
  </svg>
)
export default SvgCheckCircled
